export const FETCH_FIN_REQ_PENDING_ALL_BEGIN = 'FETCH_FIN_REQ_PENDING_ALL_BEGIN';
export const FETCH_FIN_REQ_PENDING_ALL_SUCCESS = 'FETCH_FIN_REQ_PENDING_ALL_SUCCESS';
export const FETCH_FIN_REQ_PENDING_ALL_FAILURE = 'FETCH_FIN_REQ_PENDING_ALL_FAILURE';

export const FETCH_FIN_REQ_APPROVED_ALL_BEGIN = 'FETCH_FIN_REQ_APPROVED_ALL_BEGIN';
export const FETCH_FIN_REQ_APPROVED_ALL_SUCCESS = 'FETCH_FIN_REQ_APPROVED_ALL_SUCCESS';
export const FETCH_FIN_REQ_APPROVED_ALL_FAILURE = 'FETCH_FIN_REQ_APPROVED_ALL_FAILURE';

export const FETCH_FIN_REQ_REJECTED_ALL_BEGIN = 'FETCH_FIN_REQ_REJECTED_ALL_BEGIN';
export const FETCH_FIN_REQ_REJECTED_ALL_SUCCESS = 'FETCH_FIN_REQ_REJECTED_ALL_SUCCESS';
export const FETCH_FIN_REQ_REJECTED_ALL_FAILURE = 'FETCH_FIN_REQ_REJECTED_ALL_FAILURE';

export const FETCH_FIN_REQ_APPROVE_BEGIN = 'FETCH_FIN_REQ_APPROVE_BEGIN';
export const FETCH_FIN_REQ_APPROVE_SUCCESS = 'FETCH_FIN_REQ_APPROVE_SUCCESS';
export const FETCH_FIN_REQ_APPROVE_FAILURE = 'FETCH_FIN_REQ_APPROVE_FAILURE';

export const FETCH_FIN_REQ_NUMBER_BEGIN = 'FETCH_FIN_REQ_NUMBER_BEGIN';
export const FETCH_FIN_REQ_NUMBER_SUCCESS = 'FETCH_FIN_REQ_NUMBER_SUCCESS';
export const FETCH_FIN_REQ_NUMBER_FAILURE = 'FETCH_FIN_REQ_NUMBER_FAILURE';
